import { render, staticRenderFns } from "./template-info.vue?vue&type=template&id=4f1e3b36&"
import script from "./template-info.vue?vue&type=script&lang=js&"
export * from "./template-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "template-info.vue"
export default component.exports